import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import MessageBubbleIcon from '../icons/MessageBubble';
import Button from '../buttons/Button';
import { isDarkMode } from '../../utils/helpers';

interface NoMessagesProps {
  onClick: any;
}

const NoMessages = ({ onClick }: NoMessagesProps): ReactElement => {
  return (
    <div style={{ textAlign: 'center', width: '50%', margin: '50px auto 0' }} data-test-id="no-messages-content">
      <MessageBubbleIcon height={80} width={80} />
      <p style={{ fontSize: 20, color: isDarkMode() ? '#F6F4F4' : '#212121', fontWeight: 600 }}>No Messages!</p>
      <p style={{ color: isDarkMode() ? '#AFB0B1' : '#595959', fontSize: 15, fontWeight: 400 }}>
        Send messages to plan your dates once you have an accepted and unlocked offer. Start making some offers!
      </p>
      <Button onClick={onClick} buttonType="primaryRed" customStyle={{ fontSize: 14 }}>
        Find a date
      </Button>
    </div>
  );
};

NoMessages.propTypes = {
  onClick: PropTypes.func,
};

NoMessages.defaultProps = {
  onClick: () => null,
};

export default NoMessages;
